import React from 'react';
import PropTypes from 'prop-types';
import './VenuesMapDisplay.scss';
import HighlightedVenue from './HighlightedVenue';
import CustomImage from '../../AmexGDA/CustomImage';

const VenuesMapDisplay = ({
  highlightedVenues, baseRequestUrl, pageContentByLanguage, handleDirTagging,
}) => {
  const { pgmDirWordMapImage } = pageContentByLanguage;
  const venuesCards = highlightedVenues.map((item) => {
    const { pgm_dir_continent: continent } = item;
    return (
      <HighlightedVenue
        venue={item}
        baseRequestUrl={baseRequestUrl}
        key={continent}
        handleDirTagging={handleDirTagging}
      />
    );
  });

  return (
    <>
      <div className="GDADir__VenuesMapDisplay__mainwWapper">
        <div className="GDADir__VenuesMapDisplay__worldmap">
          <CustomImage key={pgmDirWordMapImage} imageName={pgmDirWordMapImage} baseRequestUrl={baseRequestUrl} alt="World Map" />
        </div>
        <div className="GDADir__VenuesMapDisplay__cardsWrapper">
          <div className="GDADir__VenuesMapDisplay__cards">
            {venuesCards}
          </div>
        </div>
      </div>
    </>
  );
};

VenuesMapDisplay.defaultProps = {
  highlightedVenues: [],
};

VenuesMapDisplay.propTypes = {
  highlightedVenues: PropTypes.arrayOf(PropTypes.shape()),
  baseRequestUrl: PropTypes.string.isRequired,
  pageContentByLanguage: PropTypes.string.isRequired,
  handleDirTagging: PropTypes.func.isRequired,
};

export default VenuesMapDisplay;
